import { Component, LOCALE_ID, OnInit } from '@angular/core';
import { getTenantLetterAssets } from '../../../_shared/utils/letter-assets';
import { getTenantConfig } from '../../../_shared/utils/tenant-context';
import {
  OffersList,
  Personen, Positions,
  SingleOffer,
  StatusButtons
} from "../../../_shared/interfaces";
import { ClarityIcons, angleIcon, eyeHideIcon, fileIcon, minusCircleIcon, pencilIcon } from "@cds/core/icon";
import PackageJson from "../../../../../package.json";
import {
  AlertService, ConditionStoreService,
  FileStoreService, IAlertType,
  JobsStoreService,
  OffersStoreService,
  PersonsStoreService,
  ProjectsStoreService,
  StaffStoreService
} from "../../../_shared/services";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import { CurrencyPipe, DatePipe, formatCurrency, JsonPipe, NgForOf, NgIf } from "@angular/common";
import {
  ClrDatagridModule,
  ClrDropdownModule,
  ClrLoadingModule,
  ClrModalModule,
  ClrTabsModule,
  ClrTooltipModule
} from "@clr/angular";
import { JobDetailsRequestsComponent } from "../../jobs/job-details/job-details-requests/job-details-requests.component";
import { OfferEditPositionComponent } from "./offer-edit-position/offer-edit-position.component";
import { OfferDetailsDocumentsComponent } from "./offer-details-documents/offer-details-documents.component";
import { CommentFeatureCardComponent } from "../../../core/comment/comment-feature-card/comment-feature-card.component";

import { environment as env } from "../../../../environments/environment";
import {map} from "rxjs/operators";


@Component({
  selector: 'app-offer-details',
  standalone: true,
  imports: [
    JsonPipe,
    RouterLink,
    NgIf,
    ClrDropdownModule,
    CurrencyPipe,
    ClrDatagridModule,
    ClrTooltipModule,
    JobDetailsRequestsComponent,
    ClrTabsModule,
    ClrModalModule,
    OfferEditPositionComponent,
    OfferDetailsDocumentsComponent,
    ClrLoadingModule,
    NgForOf,
    DatePipe,
    CommentFeatureCardComponent
  ],
  templateUrl: './offer-details.component.html',
  styleUrl: './offer-details.component.sass',
  providers: [{ provide: LOCALE_ID, useValue: 'de'}]
})
export class OfferDetailsComponent implements OnInit {
  positions: OffersList[] = [];
  person: Personen[] = [];
  offers: SingleOffer = new SingleOffer();
  foundPositions: Positions[] = [];
  projectId: string = '';
  offerId: number = 0;
  companyId: number = 0;
  positionId: number = 0;
  partId: number = 0;
  loading1: boolean = true;
  loading2: boolean = true;
  selected: OffersList[] = [];
  editPos: number = 0;  // 0 = Anzeige; 1 = Änderungsmodus, 2 = Position ändern
  statusLabel = 'label-light-blue';
  statusText = '';
  staffFirstName: string = '';
  staffLastName: string = '';
  staffEMail: string = '';
  staffPhone: string = '';
  personFirstName: string = '';
  personLastName: string = '';
  personSalutation: string = '';
  personId: number = 0;
  offerCondition: any = "";
  deliveryCondition: any = "";
  paymentCondition: any = "";
  offerTotal: number = 0;
  erasable: boolean = false;

  public ppsverion: string = PackageJson.version;

  statusButtons: StatusButtons[] = [
    { state: 'open', display: 'Entwurf', label: 'label-light-blue', icon: 'info-circle'},
    { state: 'sent', display: 'Abgeschickt', label: 'label-light-blue', icon: 'check-circle'},
    { state: 'rejected', display: 'Entgangen', label: 'label-danger', icon: 'exclamation-circle'},
    { state: 'confirmed', display: 'Akzeptiert', label: 'label-success', icon: 'check-circle'}
  ];

  // Für Ausdruck
  basic = false;
  clrModalSize: string = 'xl';
  devMode: boolean;
  private readonly tenantConfig = getTenantConfig();

  documentDefinition = getTenantLetterAssets().a4Letter;

  constructor(
    private staffss: StaffStoreService,
    private offerss: OffersStoreService,
    private persss: PersonsStoreService,
    private projss: ProjectsStoreService,
    private filess: FileStoreService,
    private condss: ConditionStoreService,
    private jobss: JobsStoreService,
    private router: Router,
    private datePipe: DatePipe,
    private alertDispatcher: AlertService,
    private route: ActivatedRoute
  )
  {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(angleIcon, fileIcon, eyeHideIcon, pencilIcon, minusCircleIcon )
  }

  ngOnInit(): void {
    const params = this.route.snapshot.paramMap;
    this.projectId = params.get('prid') ?? '';
    this.offerId = parseInt(params.get('offid') ?? '0', 10);
    this.companyId = parseInt(this.splitProjectNumber(this.projectId, 0));
    this.loadOffer(this.projectId, this.offerId);
    this.loadOffersPositions(this.projectId, this.offerId);
    this.searchProjectPositions(this.projectId);
  }

  ngOnChange(): void {
    if (this.devMode) console.log("141 - ngOnChange Offer)");
    this.loadOffer(this.projectId, this.offerId);
    this.loadOffersPositions(this.projectId, this.offerId);
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(orderstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === orderstatus)
  };

  splitProjectNumber(projectId: string, substring: number) {
    var splits = projectId.split('.');
    return splits[substring];
  }

  loadOffer(projectId: string, offerId: number) {
    this.offerss.getOffers(projectId, offerId, 'all').subscribe({
      next: data1  => {
        if (!data1 || !data1.object) {
          this.alertDispatcher.show({
            message: 'Keine Offerdaten gefunden!',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
        this.offers = data1.object[0];
      },
        complete: () => {
          if (!this.offers) {
            this.alertDispatcher.show({
              message: ' Offer-Daten nicht verfügbar. ',
              clrAlertType: IAlertType.DANGER
            }, 2000);
            return;
          }
          // Mitarbeiter personalisieren
          this.staffStatus(this.offers.employee_phm);

          // Person ermitteln
          this.loadPersonData(this.offers.employee_leader);

          //Bedingungen ermitteln
          this.deliveryCondition = this.getCondition(this.offers.cond_delivery, 1);
          this.paymentCondition = this.getCondition(this.offers.cond_payment, 2);
          this.offerCondition = this.getCondition(this.offers.cond_offer, 3);

          // Status gestalten
          const statusline = this.findButtonStatus(this.offers.status, this.statusButtons);
          this.statusLabel = this.statusButtons[statusline].label;
          this.statusText = this.statusButtons[statusline].display;

          if (this.offers.vat_id == "null") {
          this.alertDispatcher.alertConfig.message = 'Umsatzsteuernummer des Kunden fehlt!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;

          if (this.offers.status != "open") this.erasable = true;
        this.loading1 = false;
      }
    },
    error: () => {
        return
    }
    });
  }

  loadOffersPositions(prid: string, offerid: number) {
    let factor: number;
    this.offerTotal = 0;
    this.offerss.getOffersPositions(prid, offerid, '0', 0).subscribe({
      next: data2 => {
        if (!data2 || !data2.object) {
          this.alertDispatcher.show({
            message: 'Keine Offerpositionen gefunden!',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
        this.positions = data2.object;

        this.positions.forEach((item) => {
          if (item.number_of_pieces == 0) { factor = 1 } else { factor = item.number_of_pieces }
          this.offerTotal += factor * item.selling_price;
        })

        this.updateTotal(prid, offerid, this.offerTotal);
      },
      complete: () => {
        this.loading2 = false;
      },
      error: () => {
        return
      }
    });
  }

  updateTotal(prid: string, offid: number, sum: number) {
    this.offerss.updateOfferTotal(prid, offid, sum).subscribe({
      next: () => {},
      complete: () => {
        this.alertDispatcher.show({
          message: 'Gesamtsumme wurde aktualisiert.',
          clrAlertType: IAlertType.INFO
        }, 5000);
        if (this.devMode) console.log("Summe ist: " + this.offerTotal);
      },
      error: () => {
        return
      }
    });
  }

  loadPersonData(person: number) {
    return this.persss.getSinglePersons(person)
      .subscribe( {
        next: res => {
          if (!res || !res.object) {
            this.alertDispatcher.show({
              message: 'Keine Personen gefunden!',
              clrAlertType: IAlertType.WARNING
            }, 5000);
            return;
          }
          this.person = res.object;
        },
        complete: () => {
          this.personFirstName = this.person[0].firstname;
          this.personLastName = this.person[0].lastname;
          this.personSalutation = this.person[0].salutation;
          this.personId = this.person[0].pid;
        },
        error: () => {
          return
        }
      });
  }

  deleteOffer(projectId: string, orderId: number) {
    if (confirm('Wollen Sie dieses Angebot wirklich löschen?\nDiese Aktion kann nicht rückgängig gemacht werden!')) {
      this.offerss.deleteOffer(projectId, orderId)
        .subscribe({
          next: () => {
          },
          complete: () => {
            this.router.navigate(['/project/details/', this.splitProjectNumber(projectId, 0), this.splitProjectNumber(projectId, 1)]);
          },
          error: () => {
            return
          }
        });
    }
  }

  updatePositionMode(index: number, positionId: number, partId: number) {
    this.editPos = 2;
    this.positionId = positionId;
    this.partId = partId;
  }

  async updateOffer(done: boolean) {
    this.editPos = 1;
    this.loading1 = true;
    this.loading2 = true;
    this.loadOffer(this.projectId, this.offerId);
    this.loadOffersPositions(this.projectId, this.offerId);
    this.createOffer(this.positions)
  }

  deletePosition(projectId: string, offerId: number, positionId: number, partId: number) {
    this.offerss.deleteOffersPosition(projectId, offerId, positionId.toString(), partId)
      .subscribe({
        next: () => {
        this.loadOffersPositions(projectId, offerId);
      },
      complete: () => {
        this.alertDispatcher.show({
          message: ' Position ' + positionId + '.' + partId + ' wurde gelöscht. ',
          clrAlertType: IAlertType.INFO
        }, 2000);
      },
      error: () => {
        return
      }
    });
  }

  searchProjectPositions(projectId: string) {
    this.projss.getPositions(projectId,0,0).pipe(
      map(res => (res?.object ?? []).filter(p => p.active === true))
    ).subscribe({
      next: (activePositions) => {
        if (!activePositions || activePositions.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Positionen gefunden. ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
          return;
        }
        this.foundPositions = activePositions;
      },
      error: () => {
        return;
      }
    });
  }

  addRow(position: number, part: number, technicalDrawing: string, positionName: string) {
    if (confirm('Wollen Sie die Position ' + position + '.' + part + ' ' + positionName + ' (' + technicalDrawing + ') dem Angebot wieder hinzufügen?')) {
      this.offerss.addSingleProjectPosition(this.projectId, this.offerId, position, part)
        .subscribe(data => {
          if (!data) {
            return;
          } else {
            this.loading2 = true;
            this.loadOffersPositions(this.projectId, this.offerId);
          }
        })
    }
  }

  staffStatus(staffId: number){
    this.staffss.getStaffById(staffId)
      .subscribe({
        next: staff => {
          if (!staff) {
            return;
          }
          this.staffFirstName = staff.object[0].firstname;
          this.staffLastName = staff.object[0].lastname;
          this.staffEMail = staff.object[0].email;
          this.staffPhone = staff.object[0].phone;
        },
        complete: () => {
          if (this.devMode) console.log('StaffID ist ' + staffId);
        }
      })
  }

  getCondition(condId: number, condType:number){
    if (condId == 0) {
      this.deliveryCondition = "---";
      this.paymentCondition = "---";
      this.offerCondition = "---";
    } else {
      this.condss.getConditionById(condId, condType)
        .subscribe({
            next: condition => {

              if (!condition?.object) return;
              if (!condition.object.length) return;

              switch (condType) {
                case 1:
                  this.deliveryCondition = `${condition.object[0].name} (${condition.object[0].text})`;
                  break;
                case 2:
                  this.paymentCondition = condition.object[0].name;
                  break;
                case 3:
                  this.offerCondition = condition.object[0].name;
                  break;
              }
            },
            error: () => {
              return
            }
          }
        )}
  }

  changeOfferStatus(projectId: string, offerId: number, status: number){
    if (confirm('Wollen Sie den Status dieses Angebots wirklich auf "' + this.statusButtons[status].display + '" setzen?')) {
      this.offerss.updateOfferStatus(projectId, offerId.toString(), this.statusButtons[status].state)
        .subscribe({
          next: () => {
            this.loadOffer(projectId, offerId);
            this.loadOffersPositions(projectId, offerId);
            if (this.statusButtons[status].state != "open") { this.erasable = true; } else { this.erasable = false; }
          },
          complete: () => {
            this.router.navigate(['/offer/details/', projectId, offerId]);
          }
        })
    }
  }

  // Three steps to set status and create the job

  cjUpdateOfferStatus(projectId: string, offerId: number) {
    this.offerss.updateOfferStatus(projectId, offerId.toString(), 'confirmed')
      .subscribe({
        next: () => {},
        complete: () => {
          this.cjUpdateProjectStatus(projectId, offerId);
        },
        error: err => {
          this.alertDispatcher.show({
            message: ' OfferStatus konnte nicht geändert werden - Fehler:  ' + err,
            clrAlertType: IAlertType.INFO
          }, 5000);
        }
      });
  }

  cjUpdateProjectStatus(projectId: string, offerId: number){
    const companyNo: number = parseInt(this.splitProjectNumber(projectId, 0));
    const projectNo = this.splitProjectNumber(projectId, 1);
    this.projss.updateProjectStatus(companyNo, projectNo, "confirmed")
      .subscribe({
        next: () => {},
        complete: () => {
          this.cjCreateJob(projectId, offerId);
        },
        error: err => {
          this.alertDispatcher.show({
            message: ' ProjectStatus konnte nicht geändert werden - Fehler:  ' + err,
            clrAlertType: IAlertType.INFO
          }, 5000);
        }
      });
  }

  cjCreateJob(projectId: string, offerId: number){
    let jobId = 0;
    this.jobss.createJob(projectId, offerId)
      .subscribe({
        next: response => {
          jobId = parseInt(response.message);
        },
        complete: () => {
          this.router.navigate(['/job/details/', projectId, jobId]);
        },
        error: (error) => {
          this.alertDispatcher.show({
            message: 'Fehler beim Erstellen des Jobs: ' + error,
            clrAlertType: IAlertType.DANGER
          }, 5000);
          return
        }
      });
  }

  // Init three steps see above

  createJob(projectId: string, offerId: number){
    if (confirm('Wollen Sie einen Job zu diesem Angebot (' + offerId + ') zur weiteren Bearbeitung erstellen?\nDer Status des Angebots wird auf "Akzeptiert" gesetzt, der des Projekts auf "Auftrag".')) {
      this.cjUpdateOfferStatus(projectId, offerId);
    }
  }

  duplicateOffer(projectId: string, offerId: number){
    let newOffer = 0;
    if (confirm('Wollen Sie das Angebot Nr. ' + offerId + ' duplizieren?')) {
      this.offerss.copyOffer(projectId, offerId)
        .subscribe({
          next: response => {
            newOffer = parseInt(response.message);
          },
          complete: () => {
            // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            // this.router.onSameUrlNavigation = 'reload';
            this.router.navigate(
              ['/offer/details/', projectId, newOffer],
              { queryParams: { refresh: new Date().getTime() } }
            );
          },
          error: (error) => {
            this.alertDispatcher.show({
              message: 'Fehler beim Erstellen des Jobs: ' + error,
              clrAlertType: IAlertType.DANGER
            }, 5000);
            return
          }
        });
    }
  }

  createOffer(positions: any[]) {
    let offerValue = 0.00;
    let positionFactor = 0;
    let benennung = '';
    let posTable = [[{ text: 'Pos.'}, { text: 'Bezeichnung'}, { text: 'Zeichnung', colSpan: 1, style: '' }, { text: 'Material'}, { text: ''}, { text: 'Anzahl'}, { text: 'Stückpreis in EUR', alignment: 'right' }]];

    positions.forEach(position => {
      positionFactor = 0;
      benennung = position.name;
      if (position.number_of_pieces == 0) position.number_of_pieces = '';
      if (position.for_pdf) {
        if (position.description) benennung += '\n(' + position.description + ')';
        if (position.taric && position.taric !== "0") benennung += '\n(Zolltarifnummer: ' + position.taric + ')';
        // Angebotssumme berechnen
        if (position.technology) {
          offerValue = offerValue + parseFloat(position.selling_price);
        } else {
          if (position.number_of_pieces == 0) { positionFactor = 1 } else { positionFactor = position.number_of_pieces }
          offerValue = offerValue + (positionFactor*parseFloat(position.selling_price));
        }

        switch(position.part) {
          case 0: {
            if (position.technology) {
              posTable.push(
                [ position.position, benennung, position.technical_drawing, position.material, '', '', { text: formatCurrency(position.selling_price, 'de', '', 'EUR'), alignment:'right'} ]
              );
            } else {
              posTable.push(
                [ position.position, benennung, position.technical_drawing, position.material, '', position.number_of_pieces, { text: formatCurrency(position.selling_price, 'de', '', 'EUR'), alignment:'right'} ]
              );
            }
            break;
          }
          default: {
            if (position.technology) {
              if (position.selling_price > 0) {
                posTable.push(
                  [ { text: position.position + '.' + position.part, margin: [10, 0] }, benennung, position.technical_drawing, position.material, '', '', {  text: formatCurrency(position.selling_price, 'de', '', 'EUR'), alignment:'right'} ]
                );
              } else {
                posTable.push(
                  [ { text: position.position + '.' + position.part, margin: [10, 0] }, benennung, position.technical_drawing, position.material, '', '', '' ]
                );
              }
            } else {

              if (position.selling_price > 0) {
                posTable.push(
                  [ { text: position.position + '.' + position.part, margin: [10, 0] }, benennung, position.technical_drawing, position.material, '', position.number_of_pieces, { text: formatCurrency(position.selling_price, 'de', '', 'EUR'), alignment:'right'}  ]
                );
              } else {
                posTable.push(
                  [ { text: position.position + '.' + position.part, margin: [10, 0] }, benennung, position.technical_drawing, position.material, '', position.number_of_pieces, '' ]
                );
              }
            }
            break;
          }
        }
        if (position.remarks) {
          posTable.push(
            [ { text: ""}, { text: ""}, { text: position.remarks, colSpan: 3, style: 'table' }, { text: ""}, { text: ""}, { text: ""}, { text: ""} ]
          )}
      }
    });

    this.documentDefinition.info.title = 'PPS Angebot';
    this.documentDefinition.info.subject = 'ANGEBOT ' + this.offers.project_id + '.0003.' + this.offers.offer_id;
    this.documentDefinition.info.revison = this.ppsverion;

    (this.documentDefinition.content[0] as any).columns[0].text = this.offers.company_name + '\n' + this.offers.street + '\n' + this.offers.postcode + ' ' + this.offers.city;
    if(this.offers.country && (this.offers.country != 'Deutschland')) {
      (this.documentDefinition.content[0] as any).columns[0].text += '\n' + this.offers.country
    }
    (this.documentDefinition.content[0] as any).columns[2].text = this.tenantConfig.letterCity + ', ' + this.datePipe.transform(this.offers.offer_date, "dd.MM.yyyy") + '\n\nIhr Ansprechpartner:\n' + this.staffFirstName + ' ' + this.staffLastName + '\n' + this.staffEMail + '\n' + this.staffPhone;
    this.documentDefinition.content[1].text = 'ANGEBOT ' + this.offers.project_id + '.0003.' + this.offers.offer_id ;
    if (this.offers.request_id) this.documentDefinition.content[1].text += ' (gemäß Ihrer Anfrage ' + this.offers.request_id +')';
    if(this.offers.employee_leader === 0) {
      this.documentDefinition.content[3].text = 'Sehr geehrte Damen und Herren,\n\n' +
        'Ihrer Anfrage entsprechend, bieten wir entsprechend unseren umseitigen AGB kostenfrei und verhandelbar an:';
    } else {
      this.documentDefinition.content[3].text = 'Sehr geehrte(r) ' + this.person[0].salutation + ' ' + this.person[0].lastname + ',\n\n' +
        'Ihrer Anfrage entsprechend, bieten wir entsprechend unseren umseitigen AGB kostenfrei und verhandelbar an:';
    }
    (this.documentDefinition.content[4] as any).table.headerRows = 1;
    (this.documentDefinition.content[4] as any).table.body = posTable;

    // footTable
    if (this.offers.cond_offer == 0) { this.offerCondition = '' } else { this.offerCondition = '\n' + this.offerCondition }
    if (!this.offers.delivery_remarks) { this.offers.delivery_remarks = '---'}

    this.documentDefinition.content[5] = {
      stack: [
        {
          layout: 'noBorders',
            table: {
              headerRows: 0,
                widths: [ 'auto', 'auto' ],

                body: [
                  [ 'Preis gesamt:', formatCurrency(offerValue, 'de', 'EUR', 'EUR') + ' netto, zzgl. gesetzlicher MWSt.' + this.offerCondition ],
                  [ 'Lieferbedingungen:', 'einschließlich transportfähiger und zweckmäßiger Verpackung' ],
                  [ 'Lieferzeit:', this.offers.delivery_remarks + '\n(im Rahmen freier Kapazitäten, Materialverfügbarkeit zum Zeitpunkt der Bestellung vorausgesetzt)' ],
                  [ 'Lieferung:', this.deliveryCondition + '\n(gemäß Incoterms®2020 http://www.incoterms2020.de)'],
                  [ 'Zahlungsbedingungen:', this.paymentCondition ],
                  [ 'Bindefrist:', '4 Kalenderwochen. Energiekostenabhängige Preisbestandteile werden zum Zeitpunkt der Bestellung kalkuliert und gegebenenfalls angepasst.' ]
                ]
            },
          style: 'normal',
            margin: [30, 10]
        },
      ]
    } as any;

    this.generatePdf();
  }

  async setVisibility(position: number, part: number, usePDF: boolean) {
    let pdfValue = {
      "for_pdf": usePDF,
      "offer_id": this.offerId,
      "part": part,
      "position": position,
      "project_id": this.projectId
    }

    this.offerss.updatePDFValue(pdfValue)
      .subscribe(() => {
        this.loadOffersPositions(this.projectId, this.offerId);
      });

  }

  generatePdf() {
    const documentGenerator = pdfMake.createPdf(this.documentDefinition as any);

    documentGenerator.getDataUrl((dataUrl: string) => {
      const targetElement = document.querySelector('#documentContainer');
      targetElement!.innerHTML = '';

      if (!targetElement) {
        this.alertDispatcher.alertConfig.message = 'PDF-Container nicht gefunden!';
        this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
        return; // Exit the function if the element doesn't exist
      }

      const pdfIframe = document.createElement('iframe');
      pdfIframe.src = dataUrl;
      pdfIframe.width = '100%';
      pdfIframe.height = '100%';
      targetElement.appendChild(pdfIframe);
    })
  }

  archivePdf() {
    if (confirm('Wollen Sie die Datei ' + 'Offer_' + this.offers.project_id + '.0003.' + this.offers.offer_id + '.pdf archivieren?')) {
      this.safePdf();
    }

    this.alertDispatcher.show({
      message: ' Datei ' + 'Offer_' + this.offers.project_id + '.0003.' + this.offers.offer_id + '.pdf wurde archiviert.',
      clrAlertType: IAlertType.SUCCESS
    }, 5000);
  }

  async downloadPdf(){
    if (confirm('Wollen Sie die Datei ' + 'Offer_' + this.offers.project_id + '.0003.' + this.offers.offer_id + '.pdf wirklich herunterladen?')) {
      const documentGenerator = pdfMake.createPdf(this.documentDefinition).download('Offer_' + this.offers.project_id + '.0003.' + this.offers.offer_id + '.pdf');
    }

    await this.safePdf();

    this.alertDispatcher.alertConfig.message = 'Datei ' + 'Offer_' + this.offers.project_id + '.0003.' + this.offers.offer_id + '.pdf wurde herunterladen.';
    this.alertDispatcher.alertConfig.clrAlertType = IAlertType.SUCCESS;
  }

  async printPdf() {
    if (confirm('Wollen Sie die Datei ' + 'Offer_' + this.offers.project_id + '.0003.' + this.offers.offer_id + '.pdf ausdrucken?')) {
      pdfMake.createPdf(this.documentDefinition).print();
    }

    await this.safePdf()

    this.alertDispatcher.show({
      message: ' Datei ' + 'Offer_' + this.offers.project_id + '.0003.' + this.offers.offer_id + '.pdf wurde an den Drucker übergeben. ',
      clrAlertType: IAlertType.INFO
    }, 2000);
  }

  safePdf() {
    const documentGenerator = pdfMake.createPdf(this.documentDefinition as any);
    documentGenerator.getBlob((blob: Blob) => {
      // Convert Blob to File
      const file = new File(
        [blob], // Blob content
        'Offer_' + this.offers.project_id + '.0003.' + this.offers.offer_id + '.pdf',
        { type: blob.type, lastModified: Date.now() } // File metadata
      );

      // Now, send the file instead of the Blob
      this.filess.sendFile(file, 30, this.offers.offer_id, this.offers.project_id, 0, '', 'Angebot ' + this.offers.project_id + '.0003.' + this.offers.offer_id)
        .subscribe({
          next: (data) =>
          {
            if (this.devMode) console.log("done")
          },
          complete: () => {
            this.alertDispatcher.show({
              message: ' Datei ' + 'Offer_' + this.offers.project_id + '.0003.' + this.offers.offer_id + '.pdf wurde gespeichert.',
              clrAlertType: IAlertType.SUCCESS
            }, 5000);
          },
          error: (error) => console.error("Error:", error)
        });
    });
  }

  onDelete() {
    let choosenPositions = this.selected;
    if (confirm('Wollen Sie die ausgewählten Positionen tatsächlich löschen?')) {
      choosenPositions.forEach(array => {
        this.deletePosition(this.projectId, this.offerId, array.position, array.part ?? 0)
      });

      this.loadOffer(this.projectId, this.offerId);
      this.loadOffersPositions(this.projectId, this.offerId);

      this.alertDispatcher.alertConfig.message = 'Die Positionen wurden gelöscht.';
      this.alertDispatcher.alertConfig.clrAlertType = IAlertType.SUCCESS;
    }
  }
}
